module.exports = __webpack_public_path__ + "static/media/travelFraudBanner.43074af5.svg";